import React from 'react';
import { AbsoluteFill, OffthreadVideo, useVideoConfig } from 'remotion';

interface VideoTrimPreviewProps {
  videoUrl: string;
  startTimeMs: number;
  endTimeMs: number;
}

/**
 * Remotion composition that displays only a selected segment of a video.
 * Used in the video trimmer interface to preview the trimmed region.
 *
 * This uses Remotion's optimized OffthreadVideo component for smooth
 * playback performance without manual seeking overhead.
 */
export const VideoTrimPreview: React.FC<VideoTrimPreviewProps> = ({
  videoUrl,
  startTimeMs,
  endTimeMs
}) => {
  const { fps } = useVideoConfig();

  // Calculate frame range for trimmed region
  // Use Math.max to ensure non-negative values
  const startFrame = Math.max(0, Math.floor((startTimeMs / 1000) * fps));
  const endFrame = Math.max(startFrame + 1, Math.ceil((endTimeMs / 1000) * fps));

  return (
    <AbsoluteFill style={{ backgroundColor: '#000' }}>
      <OffthreadVideo
        src={videoUrl}
        trimBefore={startFrame}
        trimAfter={endFrame}
        pauseWhenBuffering
        muted
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'contain'
        }}
      />
    </AbsoluteFill>
  );
};
